module.exports = __webpack_public_path__ + "static/media/ic_email.4632c9c9.svg";